module.exports = __webpack_public_path__ + "static/media/dash-white.b814f082.svg";